<template>
  <b-modal
    size="lg"
    v-b-tooltip.hover
    ref="viewProgressRef"
    @hidden="onViewProgressCancel"
  >
      <div
      slot="modal-header"
      class="w-100 d-flex justify-content-between"
    >
      <h5 class="mb-0">{{ patient.first_name }}'s care progress</h5>
      <span class="">
        <i
          class="fa fa-mobile clr-primary"
          aria-hidden="true"
        />
        {{ patient.mobile_no | mobileformat(patient.country_code) }}
      </span>
    </div>
    <div class="row">
      <div class="col col-12 col-lg-6 col-md-12">
        <div class="d-flex flex-column justify-content-between">
          <div class="form-group">
            <label>Days Completed (Cycle {{ totalCycles && currentCycle ?
            `${currentCycle} of ${totalCycles === 1500 ? 'Perpetual' : totalCycles}` : currentCycle }})</label>
            <span class="width float-left">
              <b-progress
                class="mt-2 daysProgress"
                :variant="bars.info"
                :value="parseInt(patientProgress ? patientProgress.days_completed: 0, 10)"
                :max="parseInt(patientProgress ? patientProgress.plan_duration: 0, 10)"
              />
            </span>
            <span class="float-left progress-count">
              {{ patientProgress ? patientProgress.days_completed : 0 }}/{{
              patientProgress ? patientProgress.plan_duration : 0 }}
            </span>
          </div>
          <div class="form-group">
            <label>Today's Progress</label>
            <span class="width float-left">
              <b-progress
                class="mt-2 daysProgress"
                :variant="bars.success"
                :value="parseInt(patientProgress ? patientProgress.today_completed_progress : 0
                                 , 10)"
                :max="parseInt(patientProgress ? patientProgress.today_progress : 0
                               , 10)"
              />
            </span>
            <span class="float-left progress-count">
              {{ patientProgress ? patientProgress.today_completed_progress : 0 }}/{{
              patientProgress ? patientProgress.today_progress : 0 }}
            </span>
          </div>
        </div>
      </div>
      <div class="col col-12 col-lg-6 col-md-12">
        <div class="form-group">
          <label>This Week</label>
          <span class="width">
            <div class="circle d-flex flex-row justify-content-between">
              <div
                v-for="(dailyIntervention, index) in progressDetail.weeklyInterventions"
                :key="index"
              >
                <div class="circle-percent-text-body">
                  <span
                    class="percent-text"
                    :style="{ 'font-size': '12px' }"
                  />
                  <div class="circleContainer">
                    <v-circle
                      ref="myprogress"
                      :progress="getDaysInterventionPercentage(dailyIntervention)"
                      :size="30"
                      line-cap="round"
                      :fill="progressFill"
                      insert-mode="append"
                      :thickness="5"
                    >
                      <p class="title">{{ weekDays[index] }}</p>
                      <span
                        v-if="getComplete(dailyIntervention)"
                        class="fa fa-check"
                      />
                    </v-circle>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <div class="text-sm text-center mt-1">
            {{ patient.first_name }}'s care plan adherence was {{ planAdherence }}% this week
          </div>
        </div>
      </div>
      <div class="col col-12">
        <div class="form-group">
          <label> Side Effects/Symptoms levels</label>
          <v-table
            :options="assessmentTableProps"
            :loading="loading"
            :data="progressDetail.assessmentAlerts"
          >
            <template slot="assessment-name">
              <div>Side Effects/</div>
              Symptoms Name
            </template>
            <template slot="assessment-target-name">
               <div>Side Effects/</div>
              Symptoms target/time
            </template>
            <template
              slot="current"
              slot-scope="slotProps"
            >
              <span :class="getActiveClass(slotProps.data.datum)">
                <b>{{ slotProps.data.datum.value }}</b>
              </span>
            </template>

            <template
              slot="createdAt"
              slot-scope="slotProps"
            >
              <span>
                {{ getFormattedDate(slotProps.data.datum.created_at, dateTimeFormat) }}
              </span>
            </template>

            <template
              slot="threshold"
              slot-scope="slotProps"
            >
              <span :class="getActiveClass(slotProps.data.datum)">
                <b>{{ slotProps.data.datum.threshold }}</b>
              </span>
            </template>
            <template
              slot="status"
              slot-scope="slotProps"
            >
              <div
                v-if="slotProps"
                class="d-flex flex-column justify-content-between align-items-center p-2"
              >
                <span :class="slotProps.data.datum.status ? 'normal' : 'unresolved'">
                  <span v-if="slotProps.data.datum.status">Normal</span>
                  <span v-else>Unresolved</span>
                </span>
              </div>
            </template>
          </v-table>
        </div>
      </div>
      <div class="col col-12">
        <div class="form-group">
          <div class="row">
            <div class="col col-12 col-md-10">
              <label>All Days</label>
            </div>
            
            <!-- <div class="col col-12 col-md-2">
              <b-form-select
                v-model="currentCycle"
                :options="totalCycleOptions"
                name="category"
              />
            </div> -->
          </div>
          <span class="width">
            <div class="circle row d-block">
              <div
                class="col col-3 col-lg-1 col-md-2 float-left"
                v-for="(cycleIntervention, index) in progressDetail.cycleInterventions"
                :key="index"
              >
                <div class="circle-percent-text-body">
                  <span
                    class="percent-text"
                    :style="{ 'font-size': '12px' }"
                  />
                  <div class="circleContainer">
                    <v-circle
                      ref="myprogress"
                      :progress="getCycleInterventionPercentage(cycleIntervention)"
                      :size="30"
                      line-cap="round"
                      :fill="progressFill"
                      insert-mode="append"
                      :thickness="5"
                    >
                      <p class="title">{{ monthDays[index] }}</p>
                      <span
                        v-if="getComplete(cycleIntervention)"
                        class="fa fa-check"
                        />
                    </v-circle>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div
      slot="modal-footer"
      class="w-100"
    >
      <b-btn
        size="sm"
        variant="outline-primary"
        class="float-right btn btn-outline-primary mr-2"
        @click="onViewProgressCancel"
      >
        Close
      </b-btn>
    </div>
    <v-loader :isLoading="isLoading" />
  </b-modal>
</template>

<script>
import VTable from '@/components/table/index.vue';
import { mapGetters } from 'vuex';
import VCircle from '@/components/circularProgressBar/ProgressBar.vue';
import colors from '@/constants/_colors';
import constants from '@/constants/app.properties';
import VLoader from '@/components/loader/index.vue';

const bars = {
  success: 'success',
  info: 'info',
  warning: 'warning',
  danger: 'danger',
  primary: 'primary',
  secondary: 'secondary',
  dark: 'dark'
};

export default {
  name: 'PatientList',
  components: {
    VTable,
    VCircle,
    VLoader
  },
  data() {
    return {
      bars,
      dateTimeFormat: constants.DAY_TIME_FORMAT,
      planAdherence: 0,
      currentCycle: '',
      fill: { gradient: [colors.cyan] },
      progressFill: { gradient: [colors.cyan] },
      patient: {},
      weekDays: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      monthDays: [],
      assessmentTableProps: {
        containerClass: 'hide-scroll',
        columns: [
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
              class: 'text-center'
            },
            headerCellSlot: {
              name: "assessment-name"
            },
            dataKey: 'assessment_name',
            dataType: String,
            label: 'Side Effects/Symptoms Name'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
            },
            headerCellSlot: {
              name: "assessment-target-name"
            },
            dataKey: 'target_or_time',
            dataType: String,
            label: 'Side Effects/Symptoms target/time'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
            },
            cellSlot: {
              name: 'current'
            },
            dataKey: 'value',
            dataType: String,
            label: 'Current'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
            },
            cellSlot: {
              name: 'createdAt'
            },
            dataKey: 'value',
            dataType: String,
            label: 'Alert Triggered'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {
            },
            cellSlot: {
              name: 'threshold'
            },
            dataKey: 'threshold',
            dataType: String,
            label: 'Threshold'
          },
          {
            headerCellProps: {
              class: 'header-cell'
            },
            cellProps: {

            },
            cellSlot: {
              name: 'status'
            },
            dataKey: 'status',
            dataType: String,
            label: 'Status'
          }
        ],
        enableSelect: false,
        page: 1,
        rowProps: {
        },
        rowsPerPage: 10,
        title: 'Patients Progress'
      },
      totalCycleOptions: [{
        value: 1,
        text: 'Cycle 1'
      }]
    };
  },
  computed: {
    ...mapGetters({
      patientList: 'progress/getPatientProgresses',
      progressDetail: 'progress/getPatientProgressDetails',
      loading: 'progress/getLoading',
      totalCount: 'progress/getTotalCount',
      isLoading: 'progress/getIsPatientProgressloading'
    }),
    patientProgress() {
      return this.progressDetail.patientProgress ?
        this.progressDetail.patientProgress[0] :
        {};
    },
    totalCycles() {
      return parseInt(this.patientProgress ? this.patientProgress.total_cyces : 0, 10);
    },
    // initalCurrentCycle() {
    //   return this.patientProgress ? this.patientProgress.current_cycle : 1;
    // }
  },
  watch: {
    // currentCycle: 'fetchPatientProgress',
    patientProgress(progressDetail) {
      this.currentCycle = progressDetail ?
        progressDetail.current_cycle :
        1;
    },
    progressDetail(progress) {
      let adherence = 0;
      progress.weeklyInterventions.forEach((intervention) => {
        const dayAdherence = this.getDaysInterventionPercentage(intervention);
        adherence += dayAdherence || 0;
      });
      this.planAdherence = (adherence / 7).toFixed(0);
    },
    // initalCurrentCycle: {
    //   handler: 'setTotalCycleOptions',
    //   immediate: true
    // }
  },
  created() {
    let i;
    const monthDays = [];
    const monthDaysCount = 31;
    for (i = 0; i < monthDaysCount; i += 1) {
      monthDays.push(`D${i}`);
    }
    this.monthDays = monthDays;
  },
  methods: {
    viewPatientProgress(patient) {
      this.patient = patient;
      this.$refs.viewProgressRef.show();
      this.$store.dispatch('progress/getPatientProgressDetails', patient.id);
    },
    onViewProgressCancel() {
      this.$refs.viewProgressRef.hide();
      this.patient = {};
      this.$emit('onViewProgressCancel');
      this.$store.dispatch('progress/resetPatientProgress');
    },
    getPercentage(data) {
      if (data.total_intervention > 0) {
        return (data.intervention_progress / data.total_intervention) * 100;
      }
      return 0;
    },
    getDaysInterventionPercentage(dailyIntervention) {
      // eslint-disable-next-line camelcase
      const { intervention_progress, total_intervention } = dailyIntervention;
      return (parseInt(intervention_progress, 10) / parseInt(total_intervention, 10)) * 100;
    },
    getCycleInterventionPercentage(cycleIntervention) {
      // eslint-disable-next-line camelcase
      const { intervention_progress, total_intervention } = cycleIntervention;
      return (parseInt(intervention_progress, 10) / parseInt(total_intervention, 10)) * 100;
    },
    getComplete(data) {
      const value = this.getPercentage(data);
      if (value === 100) {
        return true;
      }
      return false;
    },
    getBarVariant(value, max) {
      if (value >= (max / 1.5)) return bars.success;
      if (value >= (max / 2)) return bars.warning;
      if (value >= (max / 3)) return bars.danger;
      return bars.danger;
    },
    getActiveClass(data) {
      const { value, threshold, input_type } = data;
      const isValueAboveThreshold = parseInt(value, 10) >= parseInt(threshold, 10);
      return ((input_type==='MultipleChoice') || isValueAboveThreshold)  ? 'text-danger' : 'text-success';
    },
    fetchPatientProgress(cycleNo) {
      if (cycleNo) {
        const { id } = this.patient;
        this.$store.dispatch('progress/getPatientProgressByCycle', {
          cycleNo,
          id
        });
      } else {
        this.currentCycle = this.initalCurrentCycle;
        this.appNotification({
          title: '',
          text: 'Cannot view future cycles',
          type: 'warn'
        });
      }
    },
    setTotalCycleOptions(totalCycles) {
      if (totalCycles) {
        const cycleOptions = [];
        let i;
        const totalCount = parseInt(totalCycles, 10);
        for (i = 1; i <= totalCount; i += 1) {
          cycleOptions.push({
            value: i,
            text: `Cycle ${i}`
          });
        }
        this.totalCycleOptions = cycleOptions;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import './style.scss';
</style>
